import {
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY,
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FETCHING,
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_SUCCESS,
    FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    activitiesForDailySummary: {},
    activitiesForDailySummaryFetching: false,
    activitiesForDailySummaryFetchFail: false
};

// ======= Fetching Handlers =======
const fetchActivitiesForDailySummaryFetching = (state, action) => {
    return {
        activitiesForDailySummary: {
            ...state.activitiesForDailySummary
        },
        activitiesForDailySummaryFetching: true,
        activitiesForDailySummaryFetchFail: false
    };
};

const fetchActivitiesForDailySummarySuccess = (state, action) => {
    return {
        activitiesForDailySummary: {
            ...state.activitiesForDailySummary,
            [action.displayName]: {
                ...state.activitiesForDailySummary[action.displayName],
                [action.calendarDate]: action.activitiesForDailySummary
            }
        },
        activitiesForDailySummaryFetching: false,
        activitiesForDailySummaryFetchFail: false
    };
};

const fetchActivitiesForDailySummaryFail = (state, action) => {
    return {
        activitiesForDailySummary: {
            ...state.activitiesForDailySummary
        },
        activitiesForDailySummaryFetching: false,
        activitiesForDailySummaryFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FETCHING]: fetchActivitiesForDailySummaryFetching,
    [FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_SUCCESS]: fetchActivitiesForDailySummarySuccess,
    [FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FAIL]: fetchActivitiesForDailySummaryFail
};

// ======= Default Action =======
export default function activitiesForDailySummary(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchActivitiesForDailySummary(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_ACTIVITIES_FOR_DAILY_SUMMARY,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getActivitiesForDailySummary = (state, displayName, calendarDate) => {
    return state.activitiesForDailySummary.activitiesForDailySummary[displayName]
        ? state.activitiesForDailySummary.activitiesForDailySummary[displayName][calendarDate]
        : [];
};

export const isActivitiesForDailySummaryFetching = (state) => {
    return state.activitiesForDailySummary.activitiesForDailySummaryFetching;
};

export const didActivitiesForDailySummaryFetchFail = (state) => {
    return state.activitiesForDailySummary.activitiesForDailySummaryFetchFail;
};
